module.exports = __webpack_public_path__ + "img/Pack Station (WMS Module)_Page_25.ce38ee7e.jpg";